module.exports = __webpack_public_path__ + "static/media/arrow-white.c97e5056.svg";